module.exports = __webpack_public_path__ + "static/media/efterkarnevalen.25b06145.png";